import './downloadpromo.scss'

import React, {FunctionComponent, useRef} from 'react'
import {style} from 'util/campagne/style'
import {useTranslation} from 'util/i18n'
import {saveSvgAsPdf, saveSvgAsPng} from 'util/savesvg'
import {Theme} from 'views/campagne/theme'
import {Poster, PosterProps} from './poster'

export type DownloadpromoType = PosterProps
const styles = style('downloadpromo', ['poster'])

export const DownloadPromo: FunctionComponent<DownloadpromoType> = (poster) => {
	const t = useTranslation('campagne').action
	return (
		<div class={styles}>
			<div class={styles('item')}></div>
			<div class={styles('item')}>
				<Theme.H5>{t.promotion_share}</Theme.H5>
				<PosterPreview {...poster} file="poster.pdf" id="download-poster">
					<Theme.H5>{t.poster}</Theme.H5>
				</PosterPreview>
				<PosterPreview
					{...poster}
					variant="landscape"
					file="facebook_header.png"
					id="download-facebook"
				>
					<Theme.H5>{t.header}</Theme.H5>
				</PosterPreview>
				<PosterPreview
					{...poster}
					variant="square"
					file="facebook_share.png"
					id="download-social"
				>
					<Theme.H5>{t.shareimage}</Theme.H5>
				</PosterPreview>
			</div>
		</div>
	)
}
const PosterPreview: FunctionComponent<
	PosterProps & {id: string; file: string}
> = ({children, variant, file, id, ...rest}) => {
	const t = useTranslation('campagne').action
	const format = file.split('.').pop()
	const converter = format === 'pdf' ? saveSvgAsPdf : saveSvgAsPng
	const el = useRef()
	return (
		<div className={styles.poster}>
			<div className={styles.poster('image')}>
				<Poster ref={el} {...rest} variant={variant} />
			</div>
			<div className={styles.poster('link')}>
				<div>{children}</div>
				<Theme.LinkDownload
					className={styles.poster('link-download')}
					onClick={() => converter(el.current, file)}
					id={id}
				>
					{t.download}
				</Theme.LinkDownload>
			</div>
		</div>
	)
}
